import { render, staticRenderFns } from "./article_create.vue?vue&type=template&id=359b055a&scoped=true"
import script from "./article_create.vue?vue&type=script&lang=js"
export * from "./article_create.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "../../../assets/styles/management.scss?vue&type=style&index=1&id=359b055a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_16d71e7cf8bf5c3e53d15d26d70867ca/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359b055a",
  null
  
)

export default component.exports